import React from 'react';
import Header from '../components/public/Header';
import Hero from '../components/public/Hero';
import SongsSection from '../components/public/SongsSection';
import HowItWorks from '../components/public/HowItWorks';
import WebsiteReader from '../components/public/WebsiteReader';
import Songwriter from '../components/public/Songwriter';
import Marketing from '../components/public/Marketing';
import Pricing from '../components/public/Pricing';
import FAQ from '../components/public/FAQ';
import SoundToggle from '../components/SoundToggle';
import useReveal from '../hooks/useReveal';

export default function PublicSite() {
  useReveal();
  return (
    <div className="grain">
      <Header />
      <Hero />
      <SongsSection />
      <HowItWorks />
      <WebsiteReader />
      <Songwriter />
      <Marketing />
      <Pricing />
      <FAQ />
      <SoundToggle />
    </div>
  );
}
